import { PersonaGroupWithExpirationGroup } from '@/modules/group/modules/groups/domain/models/PersonaGroup'

import { axios, Response } from '../index'

const getGroupInfo = (
  groupId?: string
): Response<PersonaGroupWithExpirationGroup> => {
  return axios.get(`/v1/groups/${groupId}`)
}

export default getGroupInfo
